<template>
  <v-card
    border="opacity-50 sm"
    class="mx-auto d-flex flex-column flex-grow-1 h-100"
    max-width="360"
    rounded="xl"
    variant="text">
    <v-card-text class="text-center flex-grow-1 d-flex flex-column justify-center">
      <div class="big-number">{{ props.prepend }}{{ props.number }}</div>
      <div v-if="!isMobile" class="caption">{{ props.caption }}</div>
      <div v-else class="caption">{{ props.caption_sm }}</div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';
import { useDisplay } from 'vuetify';
const { smAndDown } = useDisplay();
let isMobile = computed(() => smAndDown.value);
// Define the props
const props = defineProps({
  number: {
    type: [Number, String],
    required: true,
  },
  caption: {
    type: String,
    required: true,
  },
  caption_sm: {
    type: String,
    required: true,
  },
  prepend: {
    type: String,
    required: false,
    default: '',
  },
});
</script>

<style scoped>
.big-number {
  font-size: 3rem;
  /* Adjust the size as needed */
  font-weight: bold;
  color: var(--color-links);
}

.caption {
  font-size: 1rem;
  color: #666;
}
</style>
